export function extractSseMessages(buffer: string): string[] {
   const parts = buffer.split("\n\n");
   if (parts.length > 1) {
      return parts.slice(0, -1).filter((part) => part.trim());
   }
   return [];
}

export function trimProcessedSseBuffer(buffer: string): string {
   const lastNewline = buffer.lastIndexOf("\n\n");
   if (lastNewline !== -1) {
      return buffer.substring(lastNewline + 2);
   }
   return buffer;
}

export function readSseDataLine(line: string): string | null {
   if (!line.startsWith("data: ")) return null;

   const json = line.replace("data: ", "").trim();
   return json || null;
}

export function isObjectStreamPayload(data: unknown): data is Record<string, any> {
   return Boolean(data) && typeof data === "object";
}

export function parseRecoverableStreamData(json: string): Record<string, any> | null {
   let data: unknown = null;

   try {
      data = JSON.parse(json);
   } catch {
      let cleanedJson = json.trim();
      if (json.includes('"context":"')) {
         const contextStart = json.indexOf('"context":"') + 11;
         const nextField = json.indexOf('","', contextStart);

         if (nextField === -1) {
            const truncatedJson =
               json.substring(0, contextStart) +
               '""' +
               (json.includes('"history":')
                  ? "," + json.substring(json.indexOf('"history":'))
                  : "}");

            try {
               JSON.parse(truncatedJson);
               return null;
            } catch (truncateError) {
               console.error("[Recovery failed]:", truncateError);
            }
         }
      }

      if (cleanedJson.endsWith('",')) {
         cleanedJson += '"}';
      } else if (cleanedJson.endsWith('"')) {
         cleanedJson += "}";
      } else if (cleanedJson.endsWith(",")) {
         cleanedJson = cleanedJson.slice(0, -1) + "}";
      }

      try {
         data = JSON.parse(cleanedJson);
      } catch {
         try {
            const parts = json.split(/[,{}]/).filter(Boolean);
            const extracted: Record<string, string> = {};

            for (const part of parts) {
               const [key, value] = part
                  .split(":")
                  .map((s) => s.trim().replace(/"/g, ""));
               if (key && value) {
                  extracted[key] = value;
               }
            }

            if (extracted.type === "complete" || extracted.type === "error") {
               data = {
                  type: extracted.type,
                  status: extracted.status || "success",
                  context: extracted.context || "",
                  message: extracted.message || ""
               };
            } else if (extracted.token) {
               data = {
                  type: "token",
                  token: extracted.token
               };
            }
         } catch (extractError) {
            console.error("[Recovery failed]:", {
               error: extractError,
               json
            });
         }
      }
   }

   return isObjectStreamPayload(data) ? data : null;
}
